export default __webpack_public_path__ + "static/media/leadship_roundtable_webinar.7796ef02.png";